export const StarIcon = ({ ...props }) => {
  return (
    <svg height="48" viewBox="0 0 48 48" width="48" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="m0 0h48v48h-48z" fill="#fff" fillOpacity=".01" />
      <path
        d="m23.9986 5-6.113 12.4776-13.8856 2.0135 10.0589 9.834-2.4045 13.6749 12.3442-6.5808 12.3468 6.5808-2.3868-13.6749 10.0414-9.834-13.8087-2.0135z"
        stroke={`${props.fill ? props.fill : '#8d8d8d'}`}
        fill={`${props.fill ? props.fill : '#fff'}`}
        strokeLinejoin="round"
        strokeWidth="4"
      />
    </svg>
  );
};
